const platform_type_options = [
  { label: 'Allegro', value: 'Allegro::Platform' },
  { label: 'Ebay', value: 'Ebay::Platform' },
  { label: 'Amazon', value: 'Amazon::Platform' },
  { label: 'Wsf', value: 'Wsf::Platform' },
  { label: 'Shoplo', value: 'Shoplo::Platform' },
  { label: 'Custom', value: 'Custom::Platform' },
  { label: 'Emag', value: 'Emag::Platform' }
]

export default platform_type_options
